(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const setup = (root = document) => {
      root.querySelectorAll('[data-collection-carousel]').forEach((carousel) => {
        if (carousel.dataset.carouselReady === 'true') return;

        const grid = carousel.querySelector('#product-grid');
        const buttons = carousel.querySelectorAll('[data-collection-carousel-button]');
        if (!grid || buttons.length === 0) return;

        carousel.dataset.carouselReady = 'true';

        const update = () => {
          const atStart = grid.scrollLeft <= 4;
          const atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
          buttons.forEach((button) => {
            button.disabled = button.dataset.collectionCarouselButton === '-1' ? atStart : atEnd;
          });
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const card = grid.querySelector('.grid__item');
            const gap = Number.parseFloat(getComputedStyle(grid).columnGap) || 0;
            const cardWidth = card ? card.getBoundingClientRect().width : grid.clientWidth * 0.45;
            const direction = Number(button.dataset.collectionCarouselButton);
            grid.scrollBy({ left: direction * (cardWidth + gap) * 2, behavior: 'smooth' });
          });
        });

        grid.addEventListener('scroll', update, { passive: true });
        new ResizeObserver(update).observe(grid);
        update();
      });
    };

    document.addEventListener('DOMContentLoaded', () => setup());
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
    setup();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-process-story]';
    const mobile = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let scheduled = false;

    const update = () => {
      scheduled = false;

      document.querySelectorAll(selector).forEach((section) => {
        if (!mobile.matches || reducedMotion.matches) {
          section.style.removeProperty('--process-panel-y');
          section.style.removeProperty('--process-panel-opacity');
          return;
        }

        const rect = section.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const start = viewportHeight * 0.78;
        const distance = viewportHeight * 0.55;
        const progress = Math.min(1, Math.max(0, (start - rect.top) / distance));

        section.style.setProperty('--process-panel-y', `${progress * -115}%`);
        section.style.setProperty('--process-panel-opacity', `${1 - progress}`);
      });
    };

    const requestUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('shopify:section:load', requestUpdate);
    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
